import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. ' +
      'Copy .env.example to .env.local and fill in the values from your Supabase project.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Required for the password-recovery flow: the reset email links back with
    // the recovery token in the URL hash, which the client exchanges for a
    // session on load. These are the library defaults; pinning them so the
    // recovery flow can't silently break if defaults ever change.
    detectSessionInUrl: true,
  },
});
